import { Box, Tooltip } from '@mui/material';

interface SessionStatusPillProps {
    status?: string | null;
}

export function SessionStatusPill({ status }: SessionStatusPillProps) {
    const getStatusColor = (status: string | null | undefined) => {
        switch (status?.toLowerCase()) {
            case 'connected':
                return {
                    background: '#00c875',
                    color: 'var(--color-surface)'
                };
            case 'disconnected':
                return {
                    background: '#e44258',
                    color: 'var(--color-surface)'
                };
            case 'initializing':
            case 'browser_started':
            case 'navigating':
                return {
                    background: '#fdab3d',
                    color: 'var(--color-surface)'
                };
            case 'unpaired':
            case 'qrcode':
                return {
                    background: '#579bfc',
                    color: 'var(--color-surface)'
                };
            default:
                return {
                    background: '#c4c4c4',
                    color: 'var(--color-surface)'
                };
        }
    };

    const isValidStatus = [
        'disconnected',
        'initializing',
        'browser_started',
        'navigating',
        'unpaired',
        'qrcode',
        'connected'
    ].includes(status?.toLowerCase() ?? '');

    const displayStatus = isValidStatus ? status : 'Unknown';

    return (
        <Tooltip title={`Status: ${displayStatus}`}>
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    px: 1.5,
                    py: 0.5,
                    borderRadius: '20px',
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    ...getStatusColor(status)
                }}
            >
                {displayStatus}
            </Box>
        </Tooltip>
    );
} 